import { render, staticRenderFns } from "./RelatedDocket.vue?vue&type=template&id=1e879f82&"
import script from "./RelatedDocket.vue?vue&type=script&lang=js&"
export * from "./RelatedDocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports